import { StatsDataPropertyInterface } from '../data/property.interface';
import { StatsStoreInterface } from '../store.interface';

export class StatsStoreProperty implements StatsStoreInterface {
  /**
   * Index of added properties
   */
  protected entity: { [key: number]: StatsDataPropertyInterface } = {};

  /**
   * @inheritDoc
   */
  public load(id: number): Promise<StatsDataPropertyInterface> {
    return new Promise((resolve, reject) => {
      if (this.entity[id]) {
        resolve(this.entity[id]);
      } else {
        reject(new Error('Stats entity property "' + id + '" not found.'));
      }
    });
  }

  /**
   * @inheritDoc
   */
  public add(data: StatsDataPropertyInterface): void {
    // Check for mandatory ID
    if (!data.id) {
      throw new Error('Unable to add property stats entity because it has no ID!');
    }

    // Keep property (data comes from PHP, so we convert it to the exact structure we expect in TS)
    this.entity[data.id] = {
      id: data.id,
      referenceNumber: data.referenceNumber,
      offeringType: data.offeringType,
      housingTypeId: data.housingTypeId,
      housingType: data.housingType,
      listingStatus: data.listingStatus,
      listingStatusDisplayed: data.listingStatusDisplayed,
      rentalPeriod: data.rentalPeriod,
      rentalPeriodId: data.rentalPeriodId,
      size: data.size,
      bedrooms: data.bedrooms,
      bathrooms: data.bathrooms,
      agentUserId: data.agentUserId,
      verified: data.verified,
      qs: data.qs,
      furnished: data.furnished,
      images: data.images,
      locations: data.locations,
      agent: {
        id: data.agent.id,
        name: data.agent.name,
        isVerified: data.agent.isVerified,
      },
      broker: {
        id: data.broker.id,
        name: data.broker.name,
      },
      rsp: data.rsp,
      rss: data.rss,
      getPriceOnApp: data.getPriceOnApp,
      price: data.price,
      priceTxt: data.priceTxt,
      currency: data.currency,
      title: data.title,
      subtitle: data.subtitle,
      url: data.url,
      mortgageRent: data.mortgageRent,
      moveSouq: data.moveSouq,
      image: data.image,
      position: data.position || 0,
      positionPage: data.positionPage || 0,
      isSmartAd: data.isSmartAd || 0,
      isCtsProperty: data.isCtsProperty || 0,
      isAreaSpecialistProperty: data.isAreaSpecialistProperty || 0,
      licenseRera: data.licenseRera || '',
      completionStatus: data.completionStatus || null,
      isExclusive: data.isExclusive || false,
      has360View: data.has360View || false,
      newProjects: data.newProjects || false,
      leadValue: data.leadValue,
    };
  }
}
